export const SeleneEvents = {};

SeleneEvents.hasActiveEvent = () => {
    return SeleneEvents.persistence()
}

SeleneEvents.displayHint = () => {
    return SeleneEvents.persistence()
}

SeleneEvents.persistence = () => {
    if(EventStateService.selenePersistence) {
        return false;
    }

    return Yosemite.McManager.getFitness() >= 2;
}
